import Vue from 'vue';
import Router from 'vue-router';
import Shop from './views/Shop.vue';
import Product from './views/Product.vue';

Vue.use(Router);

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        if (to.name !== from.name) {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        { path: '*', redirect: '/' },
        {
            path: '/',
            name: 'shop',
            component: Shop,
            beforeEnter: (to, from, next) => {
                if(document.querySelector("body").classList.contains("page-template-page-store"))
                {
                    document.querySelector('body').classList.add('site-hero-header');
                }
                next();
            },
        },
        {
            path: '/product/:id',
            name: 'product',
            component: Product,
            beforeEnter: (to, from, next) => {
                if(document.querySelector("body").classList.contains("page-template-page-store"))
                {
                    document.querySelector('body').classList.remove('site-hero-header');
                }
                next();
            },
        },
    ],
});
